<template>
  <main :class="$style.container">
    <p>Loading...</p>
  </main>
</template>

<script>
  import axios from 'axios'
  import store from '@/lib/store'
  import { jiminnyHost } from '@/helpers/region'
  import EventBus from '@/lib/event-bus'
  import { createNamespacedHelpers } from 'vuex'
  import { errorNotification } from './notifications'
  import * as Sentry from '@sentry/browser'

  const { mapActions } = createNamespacedHelpers('conference')

  export default {
    data () {
      return {
        user: store.get('user'),
        deviceId: store.get('deviceId'),
        team: store.get('team')
      }
    },
    computed: {
      hasDialpad () {
        return this.team.features.find(feature => feature.name === 'DIALER_DIALPAD')
      }
    },
    created () {
      EventBus.$on('PROCESS_PHONE_ACTION', this.handleMessage)
    },
    beforeDestroy () {
      EventBus.$off('PROCESS_PHONE_ACTION', this.handleMessage)
    },
    mounted () {
      this.handleRequest()
    },
    beforeRouteUpdate (to, from, next) {
      if (to.path === '/phone-controller') {
        this.handleRequest()
      }

      next()
    },
    methods: {
      ...mapActions({
        setCallActivity: 'setActivity'
      }),
      handleRequest () {
        store.set('phoneAction', this.$route.query)
        this.handleMessage()
      },
      handleMessage () {
        if (!store.get('token')) {
          this.$router.push('login')
          return
        }

        const phoneAction = store.get('phoneAction')

        if (phoneAction.type === 'JIMINNY.SMS') {
          this.proceed({
            path: 'sms',
            query: {
              from: encodeURIComponent(this.user.phone),
              to: phoneAction.phone,
              prospectId: phoneAction.recordId1,
              objectType: phoneAction.objectType,
              timestamp: Date.now()
            }
          })
        } else if ([
          'JIMINNY.SOFTPHONE.MOBILE',
          'JIMINNY.SOFTPHONE.PHONE',
          'JIMINNY.SOFTPHONE.PHONE-LIST'
        ].includes(phoneAction.type)) {
          this.handleRepCall(phoneAction)
        } else if (phoneAction.type === 'LIVE_COACH') {
          this.handleLiveCoach(phoneAction)
        }
      },
      async handleRepCall (phoneAction) {
        try {
          const params = {
            route: decodeURIComponent(phoneAction.type) === 'JIMINNY.SOFTPHONE.MOBILE' ? 'secondary' : 'primary',
            phoneNumber: decodeURIComponent(phoneAction.phone),
            deviceId: this.deviceId,
            prospectId: phoneAction.recordId1 ? decodeURIComponent(phoneAction.recordId1) : null,
            ...phoneAction.objectType && {objectType: decodeURIComponent(phoneAction.objectType)},
            ...phoneAction.provider && {provider: decodeURIComponent(phoneAction.provider)}
          }

          const {data: activity} = await axios.post(`${jiminnyHost()}/api/v1/activity/softphone`, params)
          this.setCallActivity(activity)
          this.proceed({ path: 'rep-call' })
        } catch (error) {
          const { data } = error.response

          Sentry.withScope(scope => {
            scope.setExtras({
              debug: false,
              providerId: decodeURIComponent(phoneAction.recordId1),
              serverResponse: data
            })
            Sentry.captureMessage('Failed to initiate call')
          })

          const invalidPhoneNumber = data.errors && data.errors.hasOwnProperty('phoneNumber')
          const errorMessageInResponse = data.error && data.error.message

          const errorMessage = invalidPhoneNumber
            ? `Failed to call ${decodeURIComponent(phoneAction.phone)} because it is an invalid phone number`
            : errorMessageInResponse || 'To dial this number please try again from the main Lead, Contact, Account or Opportunity page'

          if (invalidPhoneNumber && this.hasDialpad) {
            errorNotification({message: errorMessage}).show()

            this.$router.push({
              path: '/contacts',
              query: {
                mode: 'dialpad',
                phoneNumber: phoneAction.phone
              }
            })
          } else {
            this.$router.push({
              path: '/error-page',
              query: {
                error: encodeURIComponent(errorMessage)
              }
            })
          }
        }
      },
      async handleLiveCoach (phoneAction) {
        try {
          const {data: activity} = await axios.put(`${jiminnyHost()}/api/v1/activity/softphone`, {
            activityId: decodeURIComponent(phoneAction.activityId),
            deviceId: this.deviceId,
            isGhost: true
          })

          this.setCallActivity(activity)
          this.proceed({ path: 'live-coach-call' })
        } catch (error) {
          const { data } = error.response

          Sentry.withScope(scope => {
            scope.setExtras({
              debug: false,
              activityId: decodeURIComponent(phoneAction.activityId),
              userId: this.user.id,
              serverResponse: data
            })
            Sentry.captureMessage('Failed to join coach')
          })

          const message = data.error && data.error.message
            ? data.error.message
            : data.message

          errorNotification({ message }).show()

          this.$router.push({path: '/live-coach'})
        }
      },
      proceed ({path, query}) {
        this.$router.push({path, query}, () => {
          store.delete('phoneAction')
        })
      }
    }
  }
</script>

<style module lang="less" src="./phone-controller.less"></style>



// WEBPACK FOOTER //
// phone-controller.vue?979d9ec0